const TextParagraph = (props: any) => {
  let title = props.title ?? "";

  return (
    <div className="col-lg-12 pt-1 mb-3 text-left showCharacters">{title}</div>
  );
};

export default TextParagraph;
